module.exports = "/dog-racing/img/dog-video-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/dog-video-bck.png
// module id = 267
// module chunks = 7